var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m_about_audience"},[_c('mt-header',{attrs:{"title":"展商收藏"}},[_c('span',{attrs:{"slot":"left"},on:{"click":()=>this.$router.back()},slot:"left"},[_c('i',{staticClass:"iconfont icon-left"}),_vm._v(" 返回 ")])]),_vm._v(" 已约展品开发中...... ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }